import { useContext, useState } from "react";

import Button from "antd/lib/button";
import Modal from "antd/lib/modal";
import { ModalComponentProps } from "./types";
import Popconfirm from "antd/lib/popconfirm";
import Radio from "antd/lib/radio";
import { SessionContext } from "../../../../contexts/session/index.context";
import { TranslationContext } from "../../../../contexts/translation/index.context";
import message from "antd/lib/message";
import { request } from "../../../../services";
import styles from "./styles.module.scss";
import { useLocation } from "react-router-dom";

//UI
import checkBefore from '../../../../helpers/selectionOfActions';
import Tooltip from "antd/lib/tooltip";

export default function ModalComponent(props: ModalComponentProps) {
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();
  const { intl } = useContext(TranslationContext);

  const [selectedItem, setSelectedItem] = useState<string | null>(null);
  const [itemList, setItemList] = useState<{ id: number; email: string }[]>([]);

  const handleOk = async () => {

  //Компонент перевірка на доступ до внесення даних чи змін
  // const { isAdm } = await checkBefore(location.pathname, undefined, props.name 'load_file_mailbox');
  //   if (!isAdm) {
  //     message.error(intl("you-do-not-have-access-rights"));
  //     return;
  //   }
    let accessRights = await checkBefore(location.pathname, undefined, props.name);
    // console.log('emailprops ', props.name);
      if (!accessRights) {
        message.error(intl("you-do-not-have-access-rights"));
      return;
    }

    setLoading(true);
    // Получаем список почтовых ящиков
    const response = await request(`${location.pathname}/getlistelectronicmail`, {
      method: "get",
      cancelTokenKey: "getlistelectronicmail",
    });
    if (response?.success) {
      if (!response.content || response.content.length == 0) {
        // Если ящиков нет – показываем сообщение
        message.error(intl("electronic-mail-not-found-setting"));
        setLoading(false);
        return;
      }
      setItemList(response.content);
      if (response.content.length > 1) {
        // Если ящиков больше одного – показываем модалку
        setIsModalOpen(true);
        setLoading(false);
        return;
      } else if (response.content.length === 1) {
        // Если только один ящик – сразу выбираем его и продолжаем проверку
        continueProcessing(response.content[0].email);
      }
    } else if (!response || response?.success === false) {
      message.error(intl("electronic-mail-unable-retrieve-parameters"));
      setLoading(false);
    }
  };
  
  const continueProcessing = async (email: string | null) => {
    setIsModalOpen(false);
    setLoading(false);
    if (!email) {
      message.error(intl("electronic-mail-not-found-setting"));
      return;
    }
    if (props.setEmail) {
      props.setEmail(email); // Вызываем функцию для обновления состояния
      sessionStorage.setItem(
        "electronic_mail_data",
        JSON.stringify({
          "selectedEmail": email,
        })
      );
    }
  };


  const handleModalOk = async () => {
    try {
      if (!selectedItem) {
        message.error(intl("select-singl-electronic-mail"));
        return;
      }
      continueProcessing(selectedItem);
    } catch (errorInfo) {
      console.log("Failed:", errorInfo);
    }
  };

  const handleModalCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
    {props.popmessage? <Popconfirm
      title={props.popmessage}
      onConfirm={handleOk}
      okButtonProps={{ loading, className: styles["popconfirm"] }}
      okText={intl("ok")}
      cancelText={intl("cancel")}
    >
    {/* <Tooltip title={intl(`${props.name ? props.name : "add"}`)}> */}
      <Button
        className={props?.icon? styles["button"]: styles["button-old"]}
        icon={props?.icon}
        title={intl(props.name)}
      >
        {props?.buttonText && intl(props.buttonText)}
      </Button>
    {/* </Tooltip> */}
    </Popconfirm>:
      <Button
        className={props?.icon? styles["button"]: styles["button-old"]}
        icon={props?.icon}
        title={intl(props.name)}
        onClick={handleOk}
      >
        {props?.buttonText && intl(props.buttonText)}
      </Button>
    } 
    <Modal
        title={intl("select-singl-electronic-mail")}
        className={styles["custom-modal"]}
        open={isModalOpen}
        okText={intl("ok")}
        cancelText={intl("cancel")}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        destroyOnClose={true}
      >
        <Radio.Group onChange={(e) => setSelectedItem(e.target.value)} value={selectedItem} className={styles["ant-radio-group"]}>
          {itemList?.map((item) => (
            <Radio key={item.id} value={item.email}>
              {item.email}
            </Radio>
          ))}
        </Radio.Group>
      </Modal>
    </>
  );
}
